import axios from 'axios'
import apiAxios from '@/axios'

export async function getPortalStatus () {
  const statusUrl = import.meta.env.VITE_PORTAL_CONFIG_STATUS_URL
  if (!statusUrl) {
    throw new Error('VITE_PORTAL_CONFIG_STATUS_URL environment variable is not set')
  }
  // Use plain axios for public JSON file (no credentials needed)
  const response = await axios.get(statusUrl)
  return response.data
}

export async function updatePortalStatus (data) {
  // Use configured axios for API calls (with credentials)
  const response = await apiAxios.put(import.meta.env.VITE_API_URL + '/v1/intranet/portal-config/status', data)
  return response.data
}

export default {
  getPortalStatus,
  updatePortalStatus
}
